export default __webpack_public_path__ + "static/media/Nunito-Italic.18662850.ttf";